import {memo, useMemo} from "react";
import {Box, Heading, Text} from "@chakra-ui/react";
import MarkdownRenderer from "react-markdown";

const mdWrapperCss = {
  display: "flex",
  flexDirection: "column" as const,
  gap: "8px",
  "& h1:not(:first-child), & h2:not(:first-child), & h3:not(:first-child)": {marginTop: "12px"},
};

function buildCompactMdComponents(color: string) {
  return {
    p: (props: any) => <Text fontSize="sm" color={color} lineHeight="tall" {...props} />,
    strong: (props: any) => <Text as="strong" fontSize="sm" {...props} />,
    li: ({ordered: _ordered, ...props}: any) => <Box as="li" fontSize="sm" color={color} {...props} />,
    ul: ({ordered: _ordered, ...props}: any) => (
      <Box as="ul" ml="1em" {...props} css={{display: "flex", flexDirection: "column", gap: "4px"}} />
    ),
    ol: ({ordered: _ordered, ...props}: any) => (
      <Box as="ol" ml="1em" {...props} css={{display: "flex", flexDirection: "column", gap: "4px"}} />
    ),
    h1: (props: any) => <Heading as="h1" size="lg" {...props} />,
    h2: (props: any) => <Heading as="h2" size="md" {...props} />,
    h3: (props: any) => <Heading as="h3" size="sm" {...props} />,
  };
}

export const compactMdComponents = buildCompactMdComponents("gray.700");

export const CompactMarkdown = memo(({children, color = "gray.700"}: {children: string; color?: string}) => {
  const components = useMemo(() => buildCompactMdComponents(color), [color]);
  return (
    <Box css={mdWrapperCss}>
      <MarkdownRenderer components={components}>{children}</MarkdownRenderer>
    </Box>
  );
});
